export const fonts = {
  family: {
    pretendard: "'Pretendard', sans-serif", // 기본 폰트
    poppins: "'Poppins', sans-serif", // 타이틀용
    inter: "'Inter', sans-serif",
    rajdhani: "'Rajdhani', sans-serif;",
  },
  weight: {
    extraBold: 800,
    bold: 700,
    semiBold: 600,
    medium: 500,
    regular: 400,
    extraLight: 300,
  },
};
